import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.reduce.js";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import Head from 'next/head';
import Loader from '@meepshop/loader';
import { useGetLanguage } from '@meepshop/locales';
import { Container, ErrorPageNotFound } from "../../components";
import ProductDiscontinued from "../../components/ProductDiscontinued";

var Products = function Products(_ref) {
  var _coverImage$scaledSrc;

  var loading = _ref.loading,
      product = _ref.product,
      page = _ref.page,
      props = _objectWithoutProperties(_ref, ["loading", "product", "page"]);

  var getLanguage = useGetLanguage();
  if (loading) return /*#__PURE__*/React.createElement(Loader, {
    fullScreen: true
  });
  if (!page || !product) return /*#__PURE__*/React.createElement(ErrorPageNotFound, null);
  var status = product.status,
      coverImage = product.coverImage,
      title = product.title,
      description = product.description;
  var productImage = (coverImage === null || coverImage === void 0 ? void 0 : (_coverImage$scaledSrc = coverImage.scaledSrc) === null || _coverImage$scaledSrc === void 0 ? void 0 : _coverImage$scaledSrc.w1200) || '';
  var productName = getLanguage(title);

  var productDescription = function () {
    try {
      return JSON.parse(getLanguage(description)).blocks.reduce(function (result, _ref2) {
        var text = _ref2.text;
        return "".concat(result, " ").concat(text);
      }, '');
    } catch (e) {
      return '';
    }
  }();

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Head, null, !productName ? null : /*#__PURE__*/React.createElement("title", null, productName), !productDescription ? null : /*#__PURE__*/React.createElement("meta", {
    key: "description",
    name: "description",
    content: productDescription
  }), productName ? /*#__PURE__*/React.createElement("meta", {
    key: "keywords",
    name: "keywords",
    content: productName
  }) : null, productName ? /*#__PURE__*/React.createElement("meta", {
    key: "og:title",
    property: "og:title",
    content: productName
  }) : null, productImage ? /*#__PURE__*/React.createElement("meta", {
    key: "og:image",
    property: "og:image",
    content: productImage
  }) : null, productDescription ? /*#__PURE__*/React.createElement("meta", {
    key: "og:description",
    property: "og:description",
    content: productDescription
  }) : null), status ? /*#__PURE__*/React.createElement(Container, _extends({}, props, {
    page: page,
    product: product
  })) : /*#__PURE__*/React.createElement(ProductDiscontinued, {
    productName: productName
  }));
};

Products.propTypes = {
  product: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.object,
    status: PropTypes.number.isRequired
  }).isRequired
};

Products.getInitialProps = function (ctx) {
  var query = ctx.query;
  var pId = query.pId; // FIXME: should use get getServerSideProps return notFound

  if (!pId) throw new Error('[FIXME] pId is undefined');
  return {
    pId: pId,
    namespacesRequired: ['common', 'product-info', 'product-content']
  };
};

export default Products;